/**
 * Accordion 折叠面板封装
 *
 * - 提供受控/非受控的单面板折叠能力
 * - 仅做样式与 Radix 封装，不包含业务逻辑
 */
'use client'

import * as AccordionPrimitive from '@radix-ui/react-accordion'
import { ChevronRightIcon } from '@radix-ui/react-icons'
import * as React from 'react'
import { cname } from '../utils'

const Accordion = AccordionPrimitive.Root

const AccordionItem = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Item>
>(({ className, ...props }: any, ref) => (
  <AccordionPrimitive.Item ref={ref} className={cname('border-b', className)} {...props} />
))
AccordionItem.displayName = 'AccordionItem'

const AccordionTrigger = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Trigger>
>(({ className, children, ...props }, ref) => (
  <AccordionPrimitive.Header className="flex">
    <AccordionPrimitive.Trigger
      ref={ref}
      className={cname(
        'flex flex-1 py-4 text-sm font-medium transition-all [&[data-state=open]>svg]:rotate-90',
        className
      )}
      {...props}
    >
      <ChevronRightIcon
        color="#111"
        style={{ marginTop: props?.type === 'toollItem' ? '12px' : '' }}
        className="mx-2 h-4 w-4 shrink-0 text-muted-foreground transition-transform duration-200"
      />
      {children}
    </AccordionPrimitive.Trigger>
  </AccordionPrimitive.Header>
))
AccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName

const AccordionContent = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Content>
>(({ className, children, ...props }, ref) => (
  <AccordionPrimitive.Content
    ref={ref}
    className="data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down overflow-hidden text-sm"
    {...props}
  >
    <div className={cname('pb-4 pt-0', className)}>{children}</div>
  </AccordionPrimitive.Content>
))
AccordionContent.displayName = AccordionPrimitive.Content.displayName

export { Accordion, AccordionContent, AccordionItem, AccordionTrigger }
